import { render, staticRenderFns } from "./LegoAuditoria.vue?vue&type=template&id=50b21f15&scoped=true"
import script from "./LegoAuditoria.vue?vue&type=script&lang=js"
export * from "./LegoAuditoria.vue?vue&type=script&lang=js"
import style0 from "./LegoAuditoria.vue?vue&type=style&index=0&id=50b21f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b21f15",
  null
  
)

export default component.exports